// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProductReport":"eo_a bib_a bib_x bib_j bib_u bib_bc bib_ql bib_vv"};